import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface InfoFilledSmallProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const InfoFilledSmall = forwardRef<SVGSVGElement, InfoFilledSmallProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <path
          fill={primaryColor ?? colors.primary20}
          d='M22.5 12.004c0 5.799-4.701 10.5-10.5 10.5s-10.5-4.701-10.5-10.5c0-5.8 4.701-10.5 10.5-10.5s10.5 4.7 10.5 10.5'
        ></path>
        <path
          fill={secondaryColor ?? '#1950A3'}
          fillRule='evenodd'
          d='M10.5 16.129a1.5 1.5 0 0 0 3 0v-4.27a1.5 1.5 0 1 0-3 0zm1.5-9.75a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3'
          clipRule='evenodd'
        ></path>
      </svg>
    );
  }
);

InfoFilledSmall.displayName = 'InfoFilledSmall';

export default InfoFilledSmall;
